import React from 'react';
import { useSelector } from 'react-redux';
import { UseFormReturn } from 'react-hook-form';
import { MarginProps } from '../../../../../theme/styledProps';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { Toggle } from '../../../../../CommonComponents/OPL/Toggle/Toggle';
import { SectionHeader } from '../../../FirmSettings/components/SectionHeader/SectionHeader';
import { FormValues } from '../../MySettings.meta';
import { selectAssetBucketingHeadline } from '../../../../../CommonSelectors/CommonAreaSelector';

interface Props extends MarginProps {
  formBag: UseFormReturn<FormValues>;
  allowClientsToCustomize: boolean;
}

export const AssetBucketing: React.FC<Props> = ({ formBag, allowClientsToCustomize, ...rest }) => {
  const assetBucketingHeadline = useSelector(selectAssetBucketingHeadline);

  return (
    <Box as="section" {...rest}>
      <SectionHeader title={`Asset Bucketing - ${assetBucketingHeadline}`} />

      <Toggle {...formBag.register('allowAssetBucketingAdviser')}>
        {`Turn on ${assetBucketingHeadline} by default for All Clients`}
      </Toggle>

      {allowClientsToCustomize && (
        <Toggle {...formBag.register('allowClientToCustomizeAssetAssignmentAcrossBuckets')} mt="24">
          {`Allow Clients to Customize ${assetBucketingHeadline}`}
        </Toggle>
      )}
    </Box>
  );
};
